import React from "react";
import { MdLocationOn, MdSchool, MdCalendarToday } from "react-icons/md";

const Education = () => {
  const education = {
    id: 1,
    university: "The Ohio State University",
    universityShort: "OSU",
    degree: "B.S. In Computer Science and Engineering",
    location: "Columbus, OH",
    period: "2014 - 2019",
    coursework: [
      "Object Oriented Programming",
      "Databases",
      "Discrete Maths",
      "Advance Data Structures and Algorithms",
      "Operating Systems",
      "Computer Networks",
      "Machine Learning",
      "Data Mining",
      "Information Retrieval",
      "Image Processing",
    ],
  };

  return (
    <div
      name="education"
      className="w-full bg-gradient-to-b from-gray-950 via-zinc-900 to-slate-950 text-white py-6 md:py-8 lg:py-10"
    >
      <div className="max-w-screen-xl mx-auto px-6 md:px-8">
        <div className="mb-8 md:mb-10">
          <div className="flex items-center justify-center gap-3 mb-2">
            <div className="h-1 w-16 bg-gradient-to-r from-purple-500 to-pink-500"></div>
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-extrabold tracking-tight bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
              Education
            </h3>
            <div className="h-1 w-16 bg-gradient-to-r from-pink-500 to-purple-500"></div>
          </div>
        </div>

        {/* Centered Card Design */}
        <div className="flex justify-center">
          <div className="w-full max-w-4xl">
            <div className="relative group">
              {/* Glow Effect */}
              <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 via-pink-600 to-purple-600 rounded-2xl blur-lg opacity-20 group-hover:opacity-30 transition-opacity duration-300"></div>
              
              {/* Main Card */}
              <div className="relative bg-gradient-to-br from-gray-900/90 via-gray-800/80 to-gray-900/90 backdrop-blur-sm rounded-2xl p-6 md:p-8 shadow-2xl border border-purple-500/20 hover:border-purple-500/40 transition-all duration-300">
                {/* Header Section */}
                <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6 mb-6 pb-6 border-b border-purple-500/20">
                  {/* University Icon - Larger and More Prominent */}
                  <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 bg-gradient-to-br from-purple-600 via-pink-600 to-purple-600 rounded-2xl flex items-center justify-center shadow-xl transform group-hover:scale-110 transition-transform duration-300">
                    <MdSchool className="text-white text-3xl md:text-4xl" />
                  </div>
                  
                  {/* University and Degree Info */}
                  <div className="flex-1">
                    <h4 className="text-xl md:text-2xl lg:text-3xl font-extrabold text-white mb-2 tracking-tight">
                      {education.degree}
                    </h4>
                    <div className="flex flex-wrap items-center gap-3 md:gap-4">
                      <div className="flex items-center gap-2">
                        <MdSchool className="text-purple-400" size={18} />
                        <span className="text-sm md:text-base font-semibold text-gray-200">
                          {education.university}
                        </span>
                      </div>
                      <div className="hidden md:block w-1 h-1 bg-purple-400 rounded-full"></div>
                      <div className="flex items-center gap-2">
                        <MdLocationOn className="text-pink-400" size={18} />
                        <span className="text-sm md:text-base text-gray-300">{education.location}</span>
                      </div>
                      <div className="hidden md:block w-1 h-1 bg-purple-400 rounded-full"></div>
                      <div className="flex items-center gap-2">
                        <MdCalendarToday className="text-purple-400" size={18} />
                        <span className="text-sm md:text-base font-semibold text-purple-300">{education.period}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Relevant Coursework Section */}
                <div className="mt-6">
                  <div className="flex items-center gap-2 mb-4">
                    <div className="h-0.5 w-8 bg-gradient-to-r from-purple-500 to-pink-500"></div>
                    <h5 className="text-sm md:text-base font-bold text-purple-300 tracking-wider uppercase">
                      Relevant Coursework
                    </h5>
                    <div className="flex-1 h-0.5 bg-gradient-to-r from-pink-500 to-purple-500"></div>
                  </div>
                  
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2 md:gap-3">
                    {education.coursework.map((course, idx) => (
                      <div
                        key={idx}
                        className="group/course relative overflow-hidden rounded-lg bg-gradient-to-br from-purple-900/30 to-pink-900/30 border border-purple-500/20 hover:border-purple-400/50 transition-all duration-300 hover:scale-105"
                      >
                        <div className="absolute inset-0 bg-gradient-to-br from-purple-600/0 to-pink-600/0 group-hover/course:from-purple-600/20 group-hover/course:to-pink-600/20 transition-all duration-300"></div>
                        <span className="relative block px-3 py-2 text-[10px] xs:text-xs sm:text-xs font-medium text-purple-200 text-center">
                          {course}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Education;

